export default "__VITE_ASSET__D$17TsEb__"